module.exports = __webpack_public_path__ + "static/media/systam-success-story-quote.b4c26a30.webp";